/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_Item_0_DetailInputs */

const en_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seven times: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const es_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siete veces: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const de_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siebenmal: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const zh_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`七届：2002年、2006年、2011年、2013年、2014年、2016年、2021年`)
};

const ar_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سبع مرات: 2002، 2006، 2011، 2013، 2014، 2016، 2021`)
};

const fr_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sept fois : 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const vi_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảy lần: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const sw_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mara saba: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const th_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เจ็ดครั้ง: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const bs_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedam puta: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const ja_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7回：2002、2006、2011、2013、2014、2016、2021年`)
};

const ko_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7회: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const pt_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sete vezes: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const it_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sette volte: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const sv_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sju gånger: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const nl_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeven keer: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const da_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syv gange: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const nb_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sju ganger: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const fi_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitsemän kertaa: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const pl_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siedem razy: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const ru_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семь раз: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const tr_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yedi kez: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const hi_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सात बार: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const id_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuh kali: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const ms_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuh kali: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const cs_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedmkrát: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const el_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επτά φορές: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const he_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שבע פעמים: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const af_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sewe keer: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

const hu_about_content_honor_0_item_0_detail = /** @type {(inputs: About_Content_Honor_0_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hét alkalommal: 2002, 2006, 2011, 2013, 2014, 2016, 2021`)
};

/**
* | output |
* | --- |
* | "Seven times: 2002, 2006, 2011, 2013, 2014, 2016, 2021" |
*
* @param {About_Content_Honor_0_Item_0_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_item_0_detail = /** @type {((inputs?: About_Content_Honor_0_Item_0_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_Item_0_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_item_0_detail(inputs)
	if (locale === "de") return de_about_content_honor_0_item_0_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_0_item_0_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_0_item_0_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_0_item_0_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_0_item_0_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_0_item_0_detail(inputs)
	if (locale === "th") return th_about_content_honor_0_item_0_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_0_item_0_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_0_item_0_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_0_item_0_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_0_item_0_detail(inputs)
	if (locale === "it") return it_about_content_honor_0_item_0_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_0_item_0_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_0_item_0_detail(inputs)
	if (locale === "da") return da_about_content_honor_0_item_0_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_0_item_0_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_0_item_0_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_0_item_0_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_0_item_0_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_0_item_0_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_0_item_0_detail(inputs)
	if (locale === "id") return id_about_content_honor_0_item_0_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_0_item_0_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_0_item_0_detail(inputs)
	if (locale === "el") return el_about_content_honor_0_item_0_detail(inputs)
	if (locale === "he") return he_about_content_honor_0_item_0_detail(inputs)
	if (locale === "af") return af_about_content_honor_0_item_0_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_0_item_0_detail(inputs)
	return en_about_content_honor_0_item_0_detail(inputs)
});